import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { namespace } from 'vuex-class';
import { GET_ALL_PROJECT } from '../constants/mutation-types';
import { getAllApiResults } from '../helpers/apiCallHelpers';

@Module({ namespaced: true, name: 'CustomerModule' })
export default class CustomerModule extends VuexModule {
  private customers = [];
  private CUSTOMER_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}api/v1/customer`;

  @Mutation
  public setCustomer(customerList) {
    this.customers = customerList;
  }

  @Mutation
  public setCustomers(customerList) {
    this.customers = [];
    customerList.map(customer => {
      this.customers.push({
        id: customer.id,
        name: customer.customer_name,
        abn: customer.customer_abn
      });
    });
  }

  @Mutation
  public updateCustomerList({ index, customer }) {
    this.customers[index].abn = customer.customer_abn;
  }

  @Mutation
  public deleteCustomerList({ index, customer }) {
    this.customers.splice(index, 1);
  }

  @Action({ rawError: true })
  public async getCustomers(token) {
    return new Promise((resolve, reject) => {
      getAllApiResults(
        `${this.CUSTOMER_ENDPOINT}?per_page=1000000`,
        [],
        token,
        resolve,
        reject
      );
    })
      .then(response => {
        this.setCustomers(response);
      })
      .catch(error => console.log(error));
  }

  @Action({ rawError: true })
  public async createCustomer(payload) {
    console.log(payload);
    const { data } = await axios.post(
      this.CUSTOMER_ENDPOINT,
      {
        customer_name: payload.customer.name,
        customer_abn: payload.customer.abn
      },
      {
        headers: { Authorization: `Bearer ${payload.token}` }
      }
    );

    this.getCustomers(payload.token).catch(error => console.log(error));
  }

  @Action({ rawError: true })
  public async updateCustomer(payload) {
    const { data } = await axios.put(
      `${this.CUSTOMER_ENDPOINT}/${payload.customer.name}`,
      {
        customer_name: payload.customer.name,
        customer_abn: payload.customer.abn
      },
      {
        headers: { Authorization: `Bearer ${payload.token}` }
      }
    );

    this.getCustomers(payload.token).catch(error => console.log(error));
  }

  @Action({ rawError: true })
  public async deleteCustomer(payload) {
    const {
      status
    } = await axios.delete(
      `${this.CUSTOMER_ENDPOINT}/${payload.customer.name}`,
      { headers: { Authorization: `Bearer ${payload.token}` } }
    );

    this.deleteCustomerList(payload);
  }
}
